import React from 'react';
import { Box } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import PortalOverlay, {
  PortalOverlayHeader,
  PortalOverlayHeaderCloseBtn,
  PortalOverlayModal,
} from '../../../ui/PortalOverlay';
import { HeaderText } from '../../../ui';
import analytics from '../../../../modules/analytics';
import SearchFormContainer from './SearchFormContainer';
import { getOS } from '../../../../modules/AppInfo';
import { SEARCH_POPOVER_SOURCE, CLOSE_BUTTON_CLICKED } from './constants';
import { SearchSubmitter } from './types';

type SearchPopoverModalProps = {
  onClose: () => void;
  source?: string;
  disableAnimation?: boolean;
  query?: string;
  onSubmit?: SearchSubmitter;
  onDirectNavigation?: (name: string, params: Record<string, any>) => void;
  showIncentivesStar?: boolean;
  closeOnSubmit?: boolean;
};

export const SearchPopoverModal: React.FCWithChildren<SearchPopoverModalProps> = ({
  onClose,
  disableAnimation,
  source = SEARCH_POPOVER_SOURCE,
  query,
  onSubmit,
  onDirectNavigation,
  showIncentivesStar = false,
  closeOnSubmit = false,
}) => (
  <PortalOverlay
    name="search-popover"
    isTransparentOnMobile
    onBackdropClick={onClose}
    disableAnimation={disableAnimation}
    animationStyle={getOS() === 'ios' ? 'fadeIn' : 'slideUp'}
  >
    <PortalOverlayModal
      position="fullScreen"
      color={BrandColor.BoneLight}
    >
      <PortalOverlayHeader
        hideBottomBorder
        renderRightAction={() => (
          <PortalOverlayHeaderCloseBtn
            testID="search-popover-close"
            onCloseRequest={() => {
              analytics.track(CLOSE_BUTTON_CLICKED, {
                popover_source: source,
              });
              onClose();
            }}
          />
        )}
        renderLeftAction={() => (
          <Box
            paddingX={12}
            paddingTop={20}
          >
            <HeaderText level={2}>Search</HeaderText>
          </Box>
        )}
      />
      <SearchFormContainer
        source={source}
        initialQuery={query}
        onSubmit={onSubmit}
        onDirectNavigation={onDirectNavigation}
        showIncentivesStar={showIncentivesStar}
        closeOnSubmit={closeOnSubmit ? onClose : undefined}
      />
    </PortalOverlayModal>
  </PortalOverlay>
);
